import {
  SET_MESSAGES,
  SET_CHAT_AUTH_TOKEN,
  SET_NEW_MESSAGE,
  LOGOUT,
} from "../types/types"
import localStorage from "redux-persist/es/storage"

const initialState = {
  chatSpaceName: "",
  previousMessages: [],
  isOnline: false,
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case SET_NEW_MESSAGE:
      const messages = JSON.parse(JSON.stringify(state.previousMessages))
      messages.push(payload)
      return {
        ...state,
        previousMessages: messages,
      }

    case SET_MESSAGES:
      return {
        ...state,
        previousMessages: payload,
      }
    case SET_CHAT_AUTH_TOKEN:
      localStorage.setItem("chat_auth_token", payload)
      return {
        ...state,
      }
    case LOGOUT:
      return {
        ...initialState,
      }

    default:
      return state
  }
}
